import { openEmailSubOrderModal } from '../../../State/emailSubOrderModal'

export default () => (dispatch) => {

  dispatch(openEmailSubOrderModal())

}
